<div class="location-warehouse-app-scanner">
  <div class="location-warehouse-app__header p-6">
    <h1 class="mat-h2 font-bold">{{ title }}</h1>
  </div>

  <div class="p-6">
    <lum-ui-scanner
      class="mb-4"
      [activeDevice]="activeDevice"
      [scannerConfig]="scannerConfig"
      (scanSuccess)="onScanned($event)"
    ></lum-ui-scanner>
    <button
      class="lum-button lum-button--large w-100"
      routerLink="/warehouse-mobile-app/devices"
    >
      Back
    </button>
  </div>
</div>
